module.exports = __webpack_public_path__ + "img/hs_logo.3669e017.svg";